<template>
  <DatePicker
    :transfer="transfer"
    split-panels
    :type="dateType"
    :value="value"
    :clearable="clearable"
    :placeholder="placeholder"
    :placement="placement"
    :format="format"
    :options="dateShortcut"
    @on-change="$emit('on-change', $event), $emit('on-select-Shortcut', '')"
  />
</template>

<script>
import { enumTimeFunc } from '@/utils/Date.js'
export default {
  name: 'DateRangePicker',
  props: {
    value: {
      type: Array,
      default() {
        return []
      },
    },
    placeholder: {
      type: String,
      default: '',
    },
    placement: {
      type: String,
      default: 'bottom-start',
    },
    format: {
      type: String,
      default: 'yyyy/MM/dd',
    },
    type: {
      type: String,
      default: 'nowTime',
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    transfer: {
      type: Boolean,
      default: true,
    },
    dateType: {
      type: String,
      default: 'datetimerange',
    },
  },
  data() {
    return {
      // 日期控件的快捷选择
      dateShortcutDefault: {
        shortcuts: [],
      },
    }
  },
  computed: {
    dateShortcut() {
      let dateShortcut = this.dateShortcutDefault
      let today = {
        text: '今天',
        value() {
          return enumTimeFunc['today']()
        },
        onClick: () =>
          setTimeout(() => this.$emit('on-select-Shortcut', 'today'), 500), // 设置定时是为了覆盖触发
      }
      let yesterday = {
        text: '昨天',
        value() {
          return enumTimeFunc['yesterday']()
        },
        onClick: () =>
          setTimeout(() => this.$emit('on-select-Shortcut', 'yesterday'), 500),
      }
      let lastMonth = {
        text: '上月',
        value() {
          return enumTimeFunc['lastMonth']()
        },
        onClick: () =>
          setTimeout(() => this.$emit('on-select-Shortcut', 'lastMonth'), 500),
      }
      let thisYear = {
        text: '今年',
        value() {
          return enumTimeFunc['thisYear']()
        },
        onClick: () =>
          setTimeout(() => this.$emit('on-select-Shortcut', 'thisYear'), 500),
      }
      if (this.type === 'nowTime') {
        dateShortcut.shortcuts = [
          today,
          yesterday,
          {
            text: '本周',
            value() {
              return enumTimeFunc['thisWeek']()
            },
            onClick: () =>
              setTimeout(
                () => this.$emit('on-select-Shortcut', 'thisWeek'),
                500
              ),
          },
          {
            text: '本月',
            value() {
              return enumTimeFunc['thisMonth']()
            },
            onClick: () =>
              setTimeout(
                () => this.$emit('on-select-Shortcut', 'thisMonth'),
                500
              ),
          },
          lastMonth,
          thisYear,
        ]
      } else if (this.type === 'fulltime') {
        dateShortcut.shortcuts = [
          today,
          yesterday,
          {
            text: '本周',
            value() {
              return enumTimeFunc['thisWeek-fulltime']()
            },
            onClick: () =>
              setTimeout(
                () => this.$emit('on-select-Shortcut', 'thisWeek-fulltime'),
                500
              ),
          },
          {
            text: '本月',
            value() {
              return enumTimeFunc['thisMonth-fulltime']()
            },
            onClick: () =>
              setTimeout(
                () => this.$emit('on-select-Shortcut', 'thisMonth-fulltime'),
                500
              ),
          },
          lastMonth,
        ]
      }
      return dateShortcut
    },
  },
}
</script>

<style lang="css"></style>



// WEBPACK FOOTER //
// src/components/DateRangePicker.vue